<template>
  <b-tabs
    pills
    card
  >
    <b-tab
      title="General"
      active
      class="tab-content p-0"
    >
      <b-container>
        <b-row>
          <StudiesConfiguration />
        </b-row>
        <b-row>
          <UnitsConfiguration />
        </b-row>
      </b-container>
    </b-tab>
    <b-tab
      v-for="study in getStudiesReportViewer"
      :key="study.configId"
      class="tab-content p-0"
      :title="study.configId"
    >
      <ContinuousStudyCP
        v-if="study.base === 'PC'"
        :sectionconfig="study.configId"
        :typestudy="study.base"
      />
      <ContinuousStudyGC
        v-else-if="study.base === 'GC'"
        :sectionconfig="study.configId"
        :typestudy="study.base"
      />
      <ContinuousStudyCA
        v-else-if="study.base === 'AC'"
        :sectionconfig="study.configId"
        :typestudy="study.base"
      />
      <DiscreteStudyVD
        v-else-if="study.base === 'VD'"
        :sectionconfig="study.configId"
        :typestudy="study.base"
      />
      <DiscreteStudyPD
        v-else-if="study.base === 'PD'"
        :sectionconfig="study.configId"
        :typestudy="study.base"
      />
      <DiscreteStudyAD
        v-else-if="study.base === 'AD'"
        :sectionconfig="study.configId"
        :typestudy="study.base"
      />
      <DiscreteStudyID
        v-else-if="study.base === 'ID'"
        :sectionconfig="study.configId"
        :typestudy="study.base"
      />
      <DiscreteStudyGD
        v-else-if="study.base === 'GD'"
        :sectionconfig="study.configId"
        :typestudy="study.base"
      />
    </b-tab>
  </b-tabs>
</template>

<script>
import UnitsConfiguration from './UnitsConfiguration'
import StudiesConfiguration from './StudiesConfiguration'
import ContinuousStudyCP from './studies/ContinuousStudyCP'
import ContinuousStudyCA from './studies/ContinuousStudyCA'
import ContinuousStudyGC from './studies/ContinuousStudyGC'
import DiscreteStudyVD from './studies/DiscreteStudyVD'
import DiscreteStudyPD from './studies/DiscreteStudyPD'
import DiscreteStudyAD from './studies/DiscreteStudyAD'
import DiscreteStudyID from './studies/DiscreteStudyID'
import DiscreteStudyGD from './studies/DiscreteStudyGD'
import { PlotType, StudyManager } from '@/common/plotDefinitions.js'
import { mapGetters, mapActions } from 'vuex'

const zoneNotify = 'Tools Properties'

export default {
  name: 'ToolsProperties',
  components: {
    UnitsConfiguration,
    StudiesConfiguration,
    ContinuousStudyCP,
    ContinuousStudyCA,
    ContinuousStudyGC,
    DiscreteStudyVD,
    DiscreteStudyPD,
    DiscreteStudyAD,
    DiscreteStudyID,
    DiscreteStudyGD,
  },
    computed: mapGetters([
        'isVisibleLearningCntxlHelp',
        'getWidthLearningCntxHelp',
        'getCurrentReportViewer',
        'isReportConfigModifiedReportViewer',
        'isToolSideBarVisibleReportViewer',
        'getInitReqConfWindow',
        'getStudiesReportViewer'
    ]),
    created() {  //Maybe on mounted and consider the multi-type of studies
        if(!('configuration' in this.getCurrentReportViewer))
      this.getCurrentReportViewer.configuration={};
        const studies = []
        const studiesToRemove = []
        const studiesInConfig = Object.keys(this.getCurrentReportViewer.configuration)
    for(let j=0;j<studiesInConfig.length;j++){
            const studyBase = StudyManager.getStudyBase(studiesInConfig[j])
            if(typeof(PlotType[studyBase]) === 'undefined'){
                studiesToRemove.push(studiesInConfig[j])
                continue
            }
            studies.push({
                configId: studiesInConfig[j],
                base: studyBase
            })
        }
        this.setStudiesReportViewer(studies)
        if(studiesToRemove.length > 0){
            const warnTitle='Studies not identified'
            const warnText=`These studies were removed: ${studiesToRemove.join(', ')}. Please contact the administrator of the system.`
            studiesToRemove.forEach(studRem => delete this.getCurrentReportViewer.configuration[studRem])
            this.$notifTerm.addNotification(this.$notifTerm.typesNotif.WARNING,warnTitle,warnText,zoneNotify)
        }
  },
  methods: mapActions([
    'setStudiesReportViewer'
  ])
}
</script>

<style lang="scss" scoped>
  ::v-deep .title-section{
    border-bottom: solid 2px #707070;
    margin-bottom: 0.5rem;
  }
  ::v-deep .p-title-section{
    margin: 0 !important;
    font-weight: bolder;
    color: #707070;
  }
  ::v-deep .title-subsection{
    border-bottom: solid 1.5px #888;
    margin-bottom: 0.5rem;
  }
  ::v-deep .title-subsection p{
    margin: 0;
    font-weight: bold;
    color: #888;
  }
  ::v-deep .study-element{
    width: auto;
  }
</style>
